
export default function ExampleSection() {
  return (
    <section className="w-full scroll-mt-10" id="example-section">
      <div className="container mx-auto py-8 md:py-16 px-12">
        <div>
          <h2 className="text-center text-3xl md:text-5xl 2xl:text-6xl font-semibold tracking-tight text-blue-900">
            A quick example
          </h2>
        </div>
        <p className="text-center text-xl md:text-3xl text-orange-500 max-w-3xl mx-auto md:mt-2 origin-center">
          The RealRises BTIP is easy as 1, 2, 3
        </p>
        
        <div className="mt-10 md:mt-20 prose dark:prose-invert max-w-none">
          <div className="flex flex-col gap-3 md:gap-8">
            <img 
              alt="Bitcoin investment partnership example mobile" 
              loading="lazy" 
              width="500" 
              height="500" 
              decoding="async" 
              className="md:hidden mx-auto" 
              src="https://www.sovana.io/_next/image?url=%2Fexample.svg&w=1080&q=75"
            />
            <img 
              alt="Bitcoin investment partnership example desktop" 
              loading="lazy" 
              width="1000" 
              height="1000" 
              decoding="async" 
              className="hidden md:block mx-auto" 
              src="https://static.readdy.ai/image/c35995401d09f3a8501ef616377b3e75/2fc28e89e776c424ba345a8a0fbd0cd2.jpeg"
            />
            <div className="text-center max-w-5xl mx-auto text-xs md:text-sm">
              For simplicity, this example ignores closing costs of 2% + 3rd-party fees. The calculator{' '}
              <strong>does</strong> account for these costs.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
